/**
 * Determine if a date is a valid date
 *
 * @param {*} date
 */
function isValidDate(date) {
  return (
    date &&
    Object.prototype.toString.call(date) === "[object Date]" &&
    !isNaN(date)
  );
}

export default isValidDate;
